import { AnnouncementManagement } from "@/components/organization/AnnouncementManagement";
import { MessageSquare } from "lucide-react";

const AnnouncementsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <MessageSquare className="h-8 w-8" />
          Announcement Management
        </h1>
        <p className="text-muted-foreground mt-2">
          Create and manage announcements for your organization
        </p>
      </div>

      <AnnouncementManagement />
    </div>
  );
};

export default AnnouncementsPage;
